// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3JaTV","title":"BackImages_title__BK3HP","images":"BackImages_images__240cX"};